import { defaultLanguage } from 'shared/locale'

import { IUserSettingsStatePersisted } from 'features/userSettings/types'

type MigrationType = (state: IUserSettingsStatePersisted) => IUserSettingsStatePersisted

export const userSettingsMigrations: Record<string, MigrationType> = {
  1: state => ({
    ...state,
    data: {
      ...state.data,
      lang: defaultLanguage,
    },
  }),
}
